/**
 * This module is responsible for drawing invalidated enabled elements
 */

import { getEnabledElements } from './enabledElements.js';
import drawImage from './internal/drawImage.js';

/**
 * Draws all invalidated enabled elements and clears the invalid flag after drawing it
 *
 * @returns {void}
 * @memberof Drawing
 */
function drawInvalidated() {
  const enabledElements = getEnabledElements();

  for (const ee of enabledElements) {
    if (ee.invalid === true) {
      drawImage(ee, true);
    }
  }
}

export default drawInvalidated;
